module.exports = __webpack_public_path__ + "static/media/sensor-kit.b3e7397e.jpg";